import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SocketState } from "../context/SocketProvider";
import "../3d-game/component/common/resultPopUp.scss";
import ModalContainer from "../2d-game/modals/ModalContainer";
import Checkbox4 from "../2d-game/componenent/checkbox/Checkbox4";

// pana-local advance draw (no shared redux -> cannot affect other games)
function AdvanceDrawPana() {
  let navigate = useNavigate();
  const { socket } = SocketState();

  const [allTimeSlot, setAllTimeSlot] = useState([]);
  const [timeSlot, setTimeSlot] = useState([]);
  const [selectCount, setSelectCount] = useState(null);
  const [selectAllFlag, setSelectAllFlag] = useState(false);

  // fetch slots + capture response (self-contained)
  useEffect(() => {
    if (!socket) return;
    const onRes = (res) => {
      if (res?.en === "PLAY_MATKA_ADVANCE_DRAW_TIME_SLOT" && !res.err) {
        setAllTimeSlot(res.data?.time_slot || []);
      }
    };
    socket.on("res", onRes);
    socket.emit("req", { en: "PLAY_MATKA_ADVANCE_DRAW_TIME_SLOT", data: {} });
    return () => socket.off("res", onRes);
  }, [socket]);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = 'unset'; };
  }, []);

  useEffect(() => {
    if (allTimeSlot.length) {
      const already = JSON.parse(localStorage.getItem('pana_advance_times') || '[]');
      let timeArray = JSON.parse(JSON.stringify(allTimeSlot)).map((time) => {
        time.disable = time.status === 'completed';
        time.select = already.includes(time.time);
        return time;
      });
      setTimeSlot(timeArray);
    }
  }, [allTimeSlot]);

  // "Select All"
  useEffect(() => {
    if (timeSlot.length) {
      let copy = [...timeSlot];
      copy.forEach((t) => { t.select = false; });
      if (selectAllFlag) {
        let findIndex = copy.findIndex((t) => !t.disable);
        let count = Number(findIndex) + Number(copy.length);
        for (let i = findIndex; i < count; i++) if (copy[i]) copy[i].select = true;
      }
      setSelectCount(null);
      setTimeSlot(copy);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectAllFlag]);

  // "No of Draws" count
  useEffect(() => {
    if (timeSlot.length) {
      let copy = [...timeSlot];
      copy.forEach((t) => { t.select = false; });
      if (selectCount) {
        let findIndex = copy.findIndex((t) => !t.disable);
        let count = Number(findIndex) + Number(selectCount);
        for (let i = findIndex; i < count; i++) if (copy[i]) copy[i].select = true;
      }
      setTimeSlot(copy);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectCount]);

  const submit = () => {
    const selected = timeSlot.filter((t) => t.select).map((t) => t.time);
    localStorage.setItem('pana_advance_times', JSON.stringify(selected));
    window.dispatchEvent(new Event('panaAdvanceUpdated'));
    navigate('/pana-game');
  };

  return (
    <ModalContainer title={'Advance Draw'} navigation={'/pana-game'}>
      <div className='flex w-[90%] mx-auto flex-wrap h-[calc(100vh-40vh)] overflow-y-auto'>
        {timeSlot?.map((time, index) => (
          <div key={index} className="w-1/6 px-1 py-1.5 sm:w-1/4 xs:w-1/3 max-[480px]:w-1/2">
            <div className={`border-2 py-2 rounded-lg border-gray-300 flex items-center justify-center gap-2 cursor-pointer ${time.disable ? 'bg-gray-400' : 'bg-white'}`}>
              <Checkbox4
                disabled={time.disable}
                checked={time.select}
                onChange={(e) => {
                  const copy = [...timeSlot];
                  copy[index].select = e.target.checked;
                  setTimeSlot([...copy]);
                }}
              />
              <p className="font-semibold text-[17px]">{time.time}</p>
            </div>
          </div>
        ))}
      </div>
      <div className="absolute bottom-0 left-0 w-full pb-4 px-2 bg-white border-t border-gray-200">
        <div className='flex justify-center items-center mb-4'>
          <p className='font-semibold mr-4 text-[18px]'>No of Draws</p>
          <input
            className={`shadow appearance-none border border-black rounded w-[80px] py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline text-center mr-4 ${selectAllFlag ? 'cursor-not-allowed' : 'cursor-text'}`}
            type="text"
            value={selectCount ? selectCount : ''}
            onChange={(e) => setSelectCount(e.target.value)}
            disabled={!!selectAllFlag}
          />
          <div className='flex'>
            <Checkbox4 checked={selectAllFlag} onChange={(e) => setSelectAllFlag(e.target.checked)} />
            <p className='font-semibold text-[17px]'>Select All</p>
          </div>
        </div>

        <div className='flex justify-center'>
          <div className='w-1/5 px-1'>
            <button
              className='text-center w-full rounded-lg py-3 bg-[#374566] text-[white] font-semibold'
              onClick={() => {
                let copy = [...timeSlot];
                copy.forEach((t) => { t.select = false; });
                setTimeSlot(copy);
                setSelectCount(null);
                setSelectAllFlag(false);
              }}
            >CLEAR</button>
          </div>
          <div className='w-1/5 px-1'>
            <button className='text-center w-full rounded-lg py-3 bg-[#374566] text-[white] font-semibold' onClick={() => navigate('/pana-game')}>CANCEL</button>
          </div>
          <div className='w-1/5 px-1'>
            <button className='text-center w-full rounded-lg py-3 bg-[#e54859] text-[white] font-semibold' onClick={submit}>OK</button>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
}

export default AdvanceDrawPana;
